import { Component, forwardRef } from '@angular/core';
import { FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IGridFilter } from '../../interface/grid-filter';
import { GridFilterBase } from '../grid-filter-base';

@Component({
  standalone: false,
  selector: 'mf-grid-filter-select',
  templateUrl: './grid-filter-select.component.html',
  styleUrls: ['./grid-filter-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GridFilterSelectComponent),
      multi: true,
    },
  ],
})
export class GridFilterSelectComponent extends GridFilterBase<IGridFilter, number | null> {}
